/* global G */
import { pipe } from 'lib/util'
import { withDescriptor, withObjectFreeze } from 'trait/with'
import { withGetterSetterFn } from '@gaia/trait/with/GetterSetter'
import { hasNamespace } from 'trait/has'
import { usesNamespace, usesGetterSetter } from 'trait/uses'
import api from 'platform/adapter/message/api'

const descriptor = 'adapter:Message'

/**
 * Native Web Platform Message Adapter
 *
 * @memberOf Gaia.Adapter#
 * @typedef Adapter.Message
 *
 * @property {String} _name - module descriptor. see {@link withDescriptor}
 * @property {Object[]} G.DATA - accumulator of messages
 * @property {Object} G.API - adapter api
 * @property {Adapter.Message.API} API - adapter api revised
 *
 * @param {Gaia.Web.Application} obj - web application
 * @returns {Gaia.Adapter.Message} composition - Native Platform Web Adapter
 */
const adapterFn = (obj) => {
  const adapter = pipe(
    withDescriptor(descriptor),
    withGetterSetterFn(G.DATA),
    usesGetterSetter(G.DATA, []),
    hasNamespace(G.API),
    usesNamespace(G.API, api(obj)),
    withObjectFreeze,
  )({})

  /**
   * @type {Gaia.Adapter.EventBus}
   */
  const eventBus = obj[G.EVENTS]

  const defaults = {
    set: G.DATA,
    change: G.CHANGE,
    create: G.CREATE,
    update: G.UPDATE,
    delete: G.DELETE,
    add: G.ADD,
    cache: G.CACHE,
  }

  Object.keys(defaults).reduce(
    (acc, key) => eventBus.add(eventBus.type(G.MESSAGE, acc[key]), adapter[G.API][key]) || acc,
    defaults,
  )

  return adapter
}

export default adapterFn
